import React from 'react';
import { Form, Select, Input, InputNumber } from 'antd';
import { useGetFspsByType } from "@/modules/admin/fsps/hooks/fsp";
import { formatAmount } from "@/components/common/utils/money";
import {SelfOnboardingConfigDTO,FspType}  from '@/shared/api/model';

const { Option } = Select;

interface MobilePaymentHandlerProps {
    onFspChange: (fspCode: string) => void;
    onAmountChange: (amount: string) => void;
    onPhoneNumberChange: (phoneNumber: string) => void;
    config: SelfOnboardingConfigDTO;
    dark: boolean;
    showOtpInput?: boolean;
    isLinkedNumber?: boolean;
}

const MobilePaymentHandler: React.FC<MobilePaymentHandlerProps> = ({
                                                                       onFspChange,
                                                                       onAmountChange,
                                                                       onPhoneNumberChange,
                                                                       config,
                                                                       dark,
                                                                       showOtpInput,
                                                                       isLinkedNumber
                                                                   }) => {
    const [form] = Form.useForm();
    const [{ data: providers, isLoading: isLoadingProviders }] = useGetFspsByType(FspType.MNO);

    const handleFspChange = (value: string) => {
        onFspChange(value);
    };

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onPhoneNumberChange(e.target.value);
    };

    return (
        <Form form={form} layout="vertical">
            <Form.Item name="channelId" label="Mobile Money Provider" rules={[{ required: true }]}>
                <Select
                    showSearch
                    loading={isLoadingProviders}
                    onChange={handleFspChange}
                    placeholder="Select Mobile Money Provider"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        // @ts-ignore
                        (option?.children as string).toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {providers?.map((provider) => (
                        <Option key={provider.code} value={provider.code}>
                            {provider.name || provider.institutionName}
                        </Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item
                name="phoneNumber"
                label="Phone Number"
                rules={[{ required: true }]}
                extra={isLinkedNumber ? "This number is linked to your account" : ""}
            >
                <Input onChange={handlePhoneChange} />
            </Form.Item>

            {showOtpInput && (
                <Form.Item name="otp" label="OTP" rules={[{ required: true }]}>
                    <Input placeholder="Enter verification code" />
                </Form.Item>
            )}

            <Form.Item name="amount" label="Initial Deposit" rules={[
                { required: true },
                {
                    validator: (_, value) => {
                        // @ts-ignore
                        if (value < config.minDepositAmount) {
                            return Promise.reject(`Amount must be at least ${formatAmount(Number(config.minDepositAmount))} TZS`);
                        }
                        // @ts-ignore
                        if (value > config.maxDepositAmount) {
                            return Promise.reject(`Amount cannot exceed ${formatAmount(Number(config.maxDepositAmount))} TZS`);
                        }
                        return Promise.resolve();
                    }
                }
            ]}>
                <InputNumber
                    style={{ width: '100%' }}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    // @ts-ignore
                    parser={(value) => value!.replace(/TZS\s?|(,*)/g, "")}
                    onChange={(value) => onAmountChange(value?.toString() || '')}
                    className={dark ? 'dark-mode-input' : ''}
                    min={config.minDepositAmount}
                    max={config.maxDepositAmount}
                />
            </Form.Item>
        </Form>
    );
};

export default MobilePaymentHandler;